<section>
    <xm-btg-scheduled-switch *ngIf="(isIneligibleScheduled || ((enablePlanSevenResi || enablePlanSevenCBM) && user.account.isSegmentFive)); else ineligible"></xm-btg-scheduled-switch>
    <ng-template #ineligible>
        <xm-plan-switch-promotions 
            *ngIf="isDiscountPromotion && !isIcopPlanSwitch"
            [isBogoPromoLossForUnl]="showBogoPromoLossForUnlLines"
            [promotionType]="promotionType"
            [promotionContent]="promoContent"
            [BYOPromoContent]="promoBYOContent"
            [UNLPromoContent]="promoUNLContent"
            [extendedPromoContent]="extendedPromoContent"
            [tradeInDDAPromoContent]="tradeInDDAPromoContent">
        </xm-plan-switch-promotions>
        <xm-icop-plan-switch-promotions *ngIf="isIcopPlanSwitch"></xm-icop-plan-switch-promotions>
            
        <div class="header">{{ pageData.header }}</div>
        <div class="features">
            <div class="icon-border">
                <div class="icon" *ngIf="isUnlimited">
                    <xm-media-image class="logo" [imageOptions]="iconOption" size="auto"></xm-media-image>
                    <div class="plan-title">{{ selectedPlanData.planName }}</div>
                    <div class="icon-subhead">${{ selectedPlanData.pricePerUnit }}/{{ selectedPlanData.priceUnit }}</div>
                </div>
                <div class="icon" *ngIf="!isUnlimited">
                    <span class="icon-content" *ngIf="!isLevel5Customer">
                        <span class="icon-text">{{ selectedPlanEligibilityData.sharedDataGB }}</span>
                        <span class="icon-unit">{{ pageData.dataUnit }}</span>
                    </span>
                    <span class="icon-content" *ngIf="isLevel5Customer">
                        <span class="data-text">${{ selectedPlanData.pricePerUnit }}/{{ pageData.dataUnit }}</span>
                    </span>
                    <span class="icon-subhead" *ngIf="!selectedPlanEligibilityData.isIneligibleInUse && !selectedPlanEligibilityData.inUseOnAccount && !isLevel5Customer">
                        ${{ selectedPlanData.pricePerUnit }}/{{ selectedPlanData.priceUnit }}
                    </span>
                    <span class="data-subhead" *ngIf="isLevel5Customer">
                        {{ pageData.description }}
                    </span>
                    <div class="ineligible-inuse" role="status" [attr.aria-label]="selectedPlanData.planName + ' is ' + pageData.inUseSubheader" *ngIf="selectedPlanEligibilityData.isIneligibleInUse || selectedPlanEligibilityData.inUseOnAccount">
                        <xm-media-image aria-hidden="true" size="height" class="checkmark-icon"
                            [imageOptions]="checkmarkIcon"></xm-media-image>
                        <span class="icon-subhead">{{ pageData.inUseSubheader }}</span>
                    </div>
                </div>
            </div>
            <div class="features-details">
                <div *ngFor="let feature of features" class="plan-feature">
                    <xm-media-image aria-hidden="true" class="plan-feature-icon icon-resize"
                        [imageOptions]="getMediaImageOptions(feature.icon)"></xm-media-image>
                    <p class="body">{{ feature.header }}</p>
                </div>
            </div>
        </div>
        <div class="buttons">
            <button class="xm-btn-link-light cancel" (click)="onCancel()">{{ pageData.cancelBtn }}</button>
            <button class="xm-btn-primary-dark" (click)="navToSwitchInProgress()">{{ pageData.switchNowBtn }}</button>
        </div>
    </ng-template>
</section>
